import type { HeaderMenuConfiguration } from "../interfaces";
import actions from "@/Constants/actionsList";

// Icons
import SS from "@/assets/icons/header/motivators/SS.svg";
import SU from "@/assets/icons/header/motivators/SU.svg";
import SE from "@/assets/icons/header/motivators/SE.svg";
import AE from "@/assets/icons/header/motivators/AE-refilled.svg";
import TR from "@/assets/icons/header/motivators/TR.svg";
import TG from "@/assets/icons/header/motivators/TG.svg";

const MotivatorsMenuConfiguration: HeaderMenuConfiguration = {
	title: "Motivators",
	actions: [
		actions.VIEW_SALES_SPIFF_DEFINITIONS,
		actions.VIEW_SALES_SPIFF_AWARDS,
		actions.VIEW_SALES_TEMP_GUARANTEED,
		actions.VIEW_SPECIAL_UNIT_LISTS,
		actions.VIEW_OPPORTUNITY_MINING,
		actions.VIEW_SERVICE_SPIFF_DEFINITIONS,
		actions.VIEW_SERVICE_SPIFF_AWARDS,
		actions.VIEW_SERVICES_TRAINING,
		actions.VIEW_TEMP_GUARANTEED,
	],
	menuConfiguration: {
		submenuMinWidth: 434,
		submenuHeight: "auto",
		sections: [
			{
				name: "Sales",
				menuItemGroups: [
					{
						id: 0,
						menuItems: [
							{
								label: "Spiff Setup",
								description: "Make it Happen",
								icon: SS,
								url: "/motivators/spiff-setups",
								accessConfiguration: {
									type: "authorized",
									access: actions.VIEW_SALES_SPIFF_DEFINITIONS,
								},
							},
							{
								label: "Spiff Awards",
								description: "Get Rewarded",
								icon: SE,
								url: "/motivators/spiff-awards",
								accessConfiguration: {
									type: "authorized",
									access: actions.VIEW_SALES_SPIFF_AWARDS,
								},
							},
						],
					},
					{
						id: 1,
						menuItems: [
							{
								label: "Special Units",
								description: "Flush them out",
								icon: SU,
								url: "/motivators/special-units",
								accessConfiguration: {
									type: "authorized",
									access: actions.VIEW_SPECIAL_UNIT_LISTS,
								},
							},
						],
					},
					{
						id: 2,
						menuItems: [
							{
								label: "Opportunity Mining",
								description: "No Service",
								icon: AE,
								url: "/motivators/opportunity-mining",
								accessConfiguration: {
									type: "authorized",
									access: actions.VIEW_OPPORTUNITY_MINING,
								},
							},
						],
					},
					{
						id: 3,
						menuItems: [
							{
								label: "Temp. Guaranteed",
								description: "Sales Temporary Guaranteed",
								icon: TG,
								url: "/motivators/sales-temporary-guaranteed",
								accessConfiguration: {
									type: "authorized",
									access: actions.VIEW_SALES_TEMP_GUARANTEED,
								},
							},
						],
					},
				],
			},
			{
				name: "Services",
				menuItemGroups: [
					{
						id: 0,
						menuItems: [
							{
								label: "Spiff Setup",
								description: "Lorem ipsums",
								icon: SS,
								url: "/motivators/spiff-bonus-setups",
								accessConfiguration: {
									type: "authorized",
									access: actions.VIEW_SERVICE_SPIFF_DEFINITIONS,
								},
							},
							{
								label: "Spiff Awards",
								description: "Lorem ips",
								icon: SE,
								url: "/motivators/spiff-bonus-awards",
								accessConfiguration: {
									type: "authorized",
									access: actions.VIEW_SERVICE_SPIFF_AWARDS,
								},
							},
						],
					},
					{
						id: 1,
						menuItems: [
							{
								label: "Training",
								description: "Lorem ipsum",
								icon: TR,
								url: "/motivators/training",
								accessConfiguration: {
									type: "authorized",
									access: actions.VIEW_SERVICES_TRAINING,
								},
							},
						],
					},
					{
						id: 2,
						menuItems: [
							{
								label: "Temp. Guaranteed",
								description: "Lorem ipsum",
								icon: TG,
								url: "/motivators/temporary-guaranteed",
								accessConfiguration: {
									type: "authorized",
									access: actions.VIEW_TEMP_GUARANTEED,
								},
							},
						],
					},
				],
			},
		],
		footerItems: [],
	},
};

export default MotivatorsMenuConfiguration;
